export default "__VITE_ASSET__a0751646__"